// extracted by mini-css-extract-plugin
export var equalColumn = "_gj-0";